class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (e) => {
    const swatch = e.target.closest('[data-href]');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    // MODIF Maison Sac Cabas (24/08) : sur une carte produit (page collection),
    // on ne navigue plus vers la fiche produit au clic sur une couleur.
    // On échange simplement l'image affichée sur la carte pour celle de la
    // variante cliquée, et on reste sur la page collection.
    const imageSrc = swatch.dataset.image;
    const card = this.closest('product-card');
    const img = card ? card.querySelector('product-card-media-gallery img') : null;

    if (imageSrc && img) {
      img.src = imageSrc;
      if (swatch.dataset.srcset) {
        img.srcset = swatch.dataset.srcset;
      } else {
        img.removeAttribute('srcset');
      }

      this.querySelectorAll('[data-href][aria-checked]').forEach((el) => el.removeAttribute('aria-checked'));
      swatch.setAttribute('aria-checked', 'true');
      return;
    }

    // Repli : si on n'a pas d'image pour cette variante (produit sans photo
    // dédiée), on garde l'ancien comportement et on ouvre la fiche produit
    // directement sur cette variante.
    window.location.href = swatch.dataset.href;
  };
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}